<template>
  <div class="page" @touchmove.prevent>
    <div class="bg-window"></div>
    <div class="main">
      <!-- <div class="about-me">关于我</div>
      <div class="hint">用一段话介绍一下自己吧</div> -->
      <img class="pic-about-me" src="https://static.huiyiji520.com/cppic-1661154078.png">
      <img class="pic-hint" src="https://static.huiyiji520.com/cppic-1661173275.png">

      <van-field
        class="input-intro"
        v-model="intro"
        rows="5"
        type="textarea"
        maxlength="100"
        placeholder="认真填写可提高匹配成功率"
        show-word-limit
      />

      <div class="arrows" v-show="!showKeyboard">
        <div class="signs flex-box">
          <!-- <div class="prev" @click="goBack()"><van-icon name="arrow-left" color="#eb8e80" />上一步</div>
          <div class="next" @click="goNext()">下一步<van-icon name="arrow" color="#eb8e80" /></div> -->
          <img class="pic-prev" @click="goBack()" src="https://static.huiyiji520.com/cppic-1661159773.png">
          <img class="pic-next" @click="goNext()" src="https://static.huiyiji520.com/cppic-1661157292.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Icon, Field } from 'vant'

export default{
  components: {
    [Toast.name]: Toast,
    [Icon.name]: Icon,
    [Field.name]: Field
  },
  data(){
    return {
      intro: '',
      docmHeight: window.innerHeight, //默认屏幕高度
      showHeight: window.innerHeight, //实时屏幕高度
      showKeyboard: false
    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    },
    goBack(){
      this.$router.back()
    },
    goNext(){
      if(!this.intro){
        Toast('请填写一段自我介绍')
      }else if(this.intro.trim().length < 10){
        Toast('自我介绍需不少于10个字')
      }else{
        let cpchoose = this.$store.state.cpchoose
        cpchoose.myIntro = this.intro
        this.$store.commit('updateCpChoose', cpchoose)
        this.handleRouter('/choose_me_tags')
      }
    },
    listenPageHeight(){
      window.addEventListener('resize', () => {
        this.showHeight = window.innerHeight
        // console.log('this.showHeight:' + this.showHeight);
        // console.log('this.docmHeight:' + this.docmHeight);
        if (this.docmHeight - this.showHeight > 100) {
          //Android系统: 软键盘弹出 隐藏footer
          this.showKeyboard = true
        } else {
          //Android系统: 软键盘收起 显示footer
          this.showKeyboard = false
        }
      })
    },
    recoverIntro(){
      this.intro = this.$store.state.cpchoose.myIntro ? this.$store.state.cpchoose.myIntro : this.intro
    }
  },
  mounted(){
    this.recoverIntro()
    this.listenPageHeight()
    this.$report.submit('/choose_me_intro', this.$store.state.issue, this.$store.state.userinfo.openid)
  }
}
</script>

<style scoped>
.page{min-height:100vh;}
.bg-window{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-image: url("https://static.huiyiji520.com/cppic-1661155471.png");
  background-size:100% 100%;
  background-repeat:no-repeat;
  /* opacity:0.1; */
  z-index:-1;
}
.main{text-align:center;}
.main .about-me{margin-top:200px;margin-bottom:134px;font-size:70px;color:#eb8e80;}
.main .hint{font-size:40px;line-height:40px;color:#eb8e80;margin-bottom:132px;}
.main .pic-about-me{width:206px;height:68px;margin:0 auto;margin-top:208px;margin-bottom:134px;}
.main .pic-hint{width:457px;height:40px;margin:0 auto;margin-bottom:132px;}
.main .input-intro{width:507px;margin:0 auto;background:#fff;border:1px dashed #eb8e80;}
.main .arrows{position: fixed;bottom:120px;width:100%;}
.main .arrows .signs{
  justify-content:space-between;padding:0px 194px;
  font-size:32px;color:#eb8e80;
}
.main .pic-prev{width:120px;height:32px;}
.main .pic-next{width:120px;height:32px;}
</style>
